/*
 * The Change Password english translation.
 */
export const CHANGE_PASSWORD_EN = {
  currentPassword: 'Current Password',
  enterCurrentPassword: 'Enter current Password',
  newPassword: 'New Password',
  enterNewPassword: 'Enter new Password',
  repeatNewPassword: 'Repeat new Password',
  mustChangePasswordFirst: 'Must change Password'
}
/*
 * The Change Password german translation.
 */
export const CHANGE_PASSWORD_DE = {
  enterCurrentPassword: 'Altes Passwort eingeben',
  currentPassword: 'Altes Passwort',
  newPassword: 'Neues Passwort',
  enterNewPassword: 'Neues Passwort eingeben',
  repeatNewPassword: 'Neues Passwort wiederholen',
  mustChangePasswordFirst: 'Passwort muss geändert werden'
}
